import styled from "styled-components";
import { colors } from "../../../../../../consts";
import { Paragraph2, WrapperContainer } from "../../../../../../components";
import { IconButtonStyled } from "../../../../../../components/Buttons/styled";

export const Label = styled(Paragraph2)`
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
`;

export const Title = styled(Paragraph2)`
  font-weight: 600;
`;

export const PreviewContainer = styled(WrapperContainer)`
  border-radius: 8px;
  background: ${colors.ISABELLINE};

  position: relative;
`;

export const IconContainer = styled(WrapperContainer)`
  padding: 0 4px;
  gap: 16px;

  position: absolute;

  top: 16px;
  right: 16px;

  svg {
    path {
      fill: ${colors.RAISIN_100};
    }
  }

  ${IconButtonStyled} {
    width: 26px;
    height: 26px;
  }
`;
